import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import {
	Button,
	DatePicker,
	Image,
	Input,
	InputNumber,
	// Popconfirm,
	Tabs,
} from "antd";
import { ArrowLeftOutlined, EditOutlined } from "@ant-design/icons";
import cart from "../../assets/images/cart.png";
import {
	currencyFormat,
	fallbackString,
	isEmpty,
} from "../../lib/helpers/helpers";
import { currency } from "../../lib/helpers/currencySymbol";
import {
	AppButton,
	btnStyle,
	inputStyle,
	otpStyle,
} from "../../lib/styles/styleLibrary";
import { COLORS } from "../../lib/styles/styles";
import lock from "../../assets/svg/lock2.svg";
// import { ReactComponent as Del } from "../../assets/svg/del.svg";

import { EmptyData } from "..";
import Auth from "../../lib/middleware/auth";
// import { set } from "react-ga";
// import { useMediaQuery } from "react-responsive";

const ItemWrapper = styled.div`
	${tw`flex flex-col flex-wrap gap-2 relative`}
	input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type="number"] {
		-moz-appearance: textfield;
	}
	.ant-input-number-input {
		${tw`border-none! focus:(ring-0 ring-transparent ring-opacity-0) hover:border-none`}
	}

	.btn-group {
		position: relative;
		button {
			${tw`rounded-none text-white`}
			background: rgba(50, 50, 50, 0.801);
		}
	}

	.ant-tabs-tab {
		${tw`font-bold text-xs md:text-base hover:text-appPink`}
	}
	.ant-tabs-nav {
		&::before {
			border-bottom: none !important;
		}
	}

	.ant-tabs-nav-list {
		width: 100% !important;
		justify-content: space-evenly;
		overflow-x: scroll;
		-ms-overflow-style: none !important; /* IE and Edge */
		scrollbar-width: none !important;
		&::-webkit-scrollbar {
			display: none !important;
		}

		@media (max-width: 1217px) {
			justify-content: flex-start;
		}
	}

	.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
		color: ${COLORS.appTextDark}; //#323232;
		text-shadow: 0 0 0.25px currentColor;
	}
	.ant-tabs-ink-bar {
		${tw`bg-appTextDark`}
	}
	.ant-tabs-content-holder {
		${tw`h-full overflow-y-scroll`}
		height: 15rem;
	}
`;
const PayBtnStyle = styled.button`
	${({ selectedPay }) =>
		selectedPay
			? tw`h-16 w-full hover:(cursor-pointer ring-2 ring-appLightPink!) text-base bg-transparent rounded-2xl text-appPink border border-appPink font-bold focus:ring-2`
			: `${inputStyle};
                width: 100%;
                color: #9797BD;
                font-size: 1rem;
                height: 4rem;
            `}
`;

const ShopItem = (props) => {
	const {
		item,
		togView = () => {
			return null;
		},
		setEditVisible = () => {
			return null;
		},

		setIsEdit = () => {
			return null;
		},
		// handleDelete = () => {
		// 	return null;
		// },
	} = props;
	const experience = Auth.getExperience();
	const [visible, setVisible] = useState(false);
	const { TabPane } = Tabs;
	const [flow, setFlow] = useState("item");
	const [quantity, setQuantity] = useState(1);
	const up = (i) => {
		if (quantity > 0 && quantity < remainingQuantity) {
			setQuantity(quantity + 1);
		}
	};
	const down = (i) => {
		if (quantity !== 1) {
			setQuantity(quantity - 1);
		}
	};
	const remainingQuantity = item.quantity_provided - item.quantity_sold;
	// console.log(item, quantity, remainingQuantity);
	const fallback = fallbackString(cart);

	const handlePrevious = () => {
		switch (flow) {
			case "item":
				togView(false);
				break;
			case "buy":
				setFlow("item");
				break;
			case "card":
				setFlow("buy");
				break;
			case "pin":
				setFlow("card");
				break;
			default:
				break;
		}
	};

	// Buy Flow
	// const [selectedPay, setSelectedPay] = useState(true);
	const [payType, setPayType] = useState("wallet");

	// Pin input flow
	const [code, setCode] = useState({
		otp1: "",
		otp2: "",
		otp3: "",
		otp4: "",
	});

	const inputfocus = (elmnt) => {
		if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
			const next = elmnt.target.tabIndex - 2;

			if (next > -1) {
				elmnt.target.form.elements[next].focus();
			}
		} else {
			const next = elmnt.target.tabIndex;
			if (next < 5) {
				elmnt.target.form.elements[next].focus();
			}
		}
	};

	const handleIsEdit = () => {
		setEditVisible(true);
		setIsEdit(true);
		togView();
	};

	return (
		<ItemWrapper>
			<div
				tw="mb-4 h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800) flex flex-col items-center justify-center"
				onClick={handlePrevious}>
				<ArrowLeftOutlined tw="hover:(text-purple-800 transform scale-125)" />
			</div>
			{flow === "item" && (
				<>
					<div tw="flex flex-col md:flex-row gap-4 w-full">
						<div tw="relative">
							<Image
								preview={{ visible: false }}
								onClick={() => setVisible(true)}
								src={
									item?.shop_item_images[0]?.media_url || cart
								}
								alt={item.name}
								width={180}
								height={195}
								fallback={`data:image/png;base64,${fallback}`}
								tw="rounded-2xl shadow-md bg-gray-200 min-h-full min-w-full"
								placeholder={
									<Image
										preview={false}
										src={
											item.shop_item_images[0]
												?.media_url_min || cart
										}
										width={200}
									/>
								}
							/>
							<div style={{ display: "none" }}>
								<Image.PreviewGroup
									preview={{
										visible,
										onVisibleChange: (vis) =>
											setVisible(vis),
									}}>
									{item?.shop_item_images?.map((img, i) => {
										return (
											<Image
												key={i}
												src={img?.media_url || cart}
												alt={item.name}
												width={180}
												height={195}
												fallback={`data:image/png;base64,${fallback}`}
												tw="rounded-2xl shadow-md bg-gray-200 min-h-full min-w-full"
												placeholder={
													<Image
														preview={false}
														src={
															img.media_url_min ||
															cart
														}
														width={200}
													/>
												}
											/>
										);
									})}
								</Image.PreviewGroup>{" "}
							</div>

							<div className="btn-group">
								<div tw="inline-flex absolute bottom-4 left-8">
									<Button
										tw="rounded-tl-md! rounded-bl-md!"
										onClick={down}>
										-
									</Button>
									<input
										type="number"
										value={quantity}
										onChange={(e) =>
											setQuantity(e.target.value)
										}
										tw="w-8 p-0 h-8 border-none! text-center cursor-default! text-appTextDark! bg-white! font-bold hover:(border-none)"
									/>

									<Button
										tw="rounded-tr-md! rounded-br-md!"
										onClick={up}>
										+
									</Button>
								</div>
							</div>
						</div>
						<div tw="flex flex-col justify-between w-full gap-8">
							<p tw="mt-4 text-base md:text-2xl text-appTextFaded font-semibold">
								{item.name}
							</p>
							<p tw="text-base md:text-2xl font-extrabold">
								{currency()} {currencyFormat(item.price)}
							</p>
							<div tw="flex flex-row gap-4 ">
								{experience === "guest" ? (
									<AppButton
										tw="rounded-md w-full md:w-7/12"
										onClick={() => {
											setFlow("buy");
										}}>
										ADD TO CART
									</AppButton>
								) : (
									<div tw="flex flex-row items-center  gap-6 justify-around">
										{/* <Popconfirm
											placement="top"
											title={
												"Are you sure to delete this item?"
											}
											onConfirm={() => {
												handleDelete(item?.id);
											}}
											okText="Yes"
											cancelText="No">
											<Del tw="p-1.5 bg-appLightPink h-12 w-10  rounded-md hover:(shadow-md cursor-pointer)" />
										</Popconfirm> */}

										<EditOutlined
											tw="bg-appLightPink h-12 w-10 text-2xl text-appPink p-2 rounded-md hover:(shadow-md p-1.5 cursor-pointer)"
											onClick={() => handleIsEdit()}
										/>
									</div>
								)}
							</div>
						</div>
					</div>
					<div tw="mt-4 w-full">
						<Tabs defaultActiveKey="1" tabPosition={"top"} animated>
							<TabPane tab="Description" key="1">
								<div tw="p-2 whitespace-pre-wrap">
									{isEmpty(item.description) ? (
										<div tw="h-full flex flex-col items-center justify-center">
											<EmptyData description="No data" />
										</div>
									) : (
										item.description
									)}
								</div>
							</TabPane>
							<TabPane tab="Shipping info" key="2">
								<div tw="p-2">
									{isEmpty(item.shipping) ? (
										<div tw="h-full flex flex-col items-center justify-center">
											<EmptyData description="No data" />
										</div>
									) : (
										item.shipping
									)}
								</div>
							</TabPane>
							<TabPane tab="Payment options" key="3">
								<div tw="whitespace-pre-wrap text-justify">
									<p tw="font-semibold">
										Payment - {item.payment_option}
									</p>
								</div>
							</TabPane>
						</Tabs>
					</div>
				</>
			)}

			{flow === "buy" && (
				<>
					<div>
						<div>
							<label tw="font-bold text-lg">
								Delivery Address
							</label>
							<Input
								placeholder="40, Adeola Odeku, Lagos"
								type="text"
								css={inputStyle}
								tw="mt-4"
								// onChange={(e) => {
								// 	setFields({
								// 		...fields,
								// 		email: e.target.value.trim(),
								// 	});
								// }}
							/>
						</div>
						<div>
							<label tw="font-bold text-lg">Phone number</label>
							<Input
								placeholder="08123456789"
								type="number"
								css={inputStyle}
								tw="mt-4"
								// onChange={(e) => {
								// 	setFields({
								// 		...fields,
								// 		email: e.target.value.trim(),
								// 	});
								// }}
							/>
						</div>
						<div tw="mt-4 flex flex-row flex-wrap md:flex-nowrap gap-4 w-full">
							<PayBtnStyle
								tw="rounded-md"
								selectedPay={payType === "wallet" && true}
								onClick={() => {
									setPayType("wallet");
								}}>
								Pay with wallet
							</PayBtnStyle>
							<PayBtnStyle
								tw="rounded-md"
								selectedPay={payType === "card" && true}
								onClick={() => {
									setPayType("card");
								}}>
								Pay with Card
							</PayBtnStyle>
						</div>
					</div>

					<div tw="mt-8 mb-8">
						<button
							css={btnStyle}
							tw="rounded-lg"
							onClick={() => setFlow("card")}>
							Continue
						</button>
					</div>
				</>
			)}

			{flow === "card" && (
				<>
					<div>
						<div>
							<label tw="font-semibold text-lg">
								Name on card
							</label>
							<Input
								placeholder="Ayodeji Osindele"
								type="text"
								css={inputStyle}
								tw="mt-4"
								// onChange={(e) => {
								// 	setFields({
								// 		...fields,
								// 		email: e.target.value.trim(),
								// 	});
								// }}
							/>
						</div>
						<div>
							<label tw="font-semibold text-lg">
								Card number
							</label>
							<Input
								placeholder="0000 0000 0000 0000"
								type="number"
								css={inputStyle}
								tw="mt-4"
								// onChange={(e) => {
								// 	setFields({
								// 		...fields,
								// 		email: e.target.value.trim(),
								// 	});
								// }}
							/>
						</div>
						<div tw="mt-4 flex flex-row flex-wrap md:flex-nowrap gap-4 w-full">
							<div>
								<label tw="font-semibold text-lg">Date</label>
								<div>
									<DatePicker
										placeholder="YYYY-MM"
										css={inputStyle}
										tw="mt-4 w-full!"
										picker="month"
										suffixIcon={""}
										// value={md}
										// disabledDate={(current) => {
										// 	return current && current > moment();
										// }}
										// onChange={(date) => setMd(date)}
									/>
								</div>
							</div>
							<div>
								<label tw="font-semibold text-lg">CVV</label>
								<Input
									placeholder="123"
									type="number"
									maxLength={3}
									css={inputStyle}
									tw="mt-4 w-full"
									// onChange={(e) => {
									// 	setFields({
									// 		...fields,
									// 		email: e.target.value.trim(),
									// 	});
									// }}
								/>
							</div>
						</div>
					</div>

					<div tw="mt-8 mb-8">
						<button
							css={btnStyle}
							tw="rounded-lg"
							onClick={() => setFlow("pin")}>
							Continue
						</button>
					</div>
				</>
			)}

			{flow === "pin" && (
				<>
					<h1 tw="text-center font-semibold text-lg">
						Enter transaction PIN
					</h1>

					<div tw="flex flex-row flex-nowrap items-center justify-between mt-4 p-4">
						<InputNumber
							name="otp1"
							type="text"
							autoComplete="off"
							value={code.otp1}
							placeholder="-"
							css={otpStyle}
							onChange={(e) => {
								setCode({ ...code, otp1: e });

								console.log(e);
							}}
							tabIndex="1"
							min="0"
							maxLength="1"
							onKeyUp={(e) => inputfocus(e)}
						/>
						<InputNumber
							name="otp2"
							type="number"
							autoComplete="off"
							css={otpStyle}
							value={code.otp2}
							placeholder="-"
							onChange={(e) =>
								setCode({
									...code,
									otp2: e,
								})
							}
							tabIndex="2"
							min="0"
							maxLength="1"
							onKeyUp={(e) => inputfocus(e)}
						/>
						<InputNumber
							name="otp3"
							type="number"
							autoComplete="off"
							css={otpStyle}
							value={code.otp3}
							placeholder="-"
							onChange={(e) =>
								setCode({
									...code,
									otp3: e,
								})
							}
							tabIndex="3"
							maxLength="1"
							min="0"
							onKeyUp={(e) => inputfocus(e)}
						/>
						<InputNumber
							name="otp4"
							type="number"
							css={otpStyle}
							autoComplete="off"
							value={code.otp4}
							placeholder="-"
							onChange={(e) =>
								setCode({
									...code,
									otp4: e,
								})
							}
							tabIndex="4"
							maxLength="1"
							min="0"
							onKeyUp={(e) => inputfocus(e)}
						/>
					</div>

					<div tw="mt-8 mb-8">
						<button
							css={btnStyle}
							tw="rounded-lg flex flex-row flex-nowrap items-center justify-center gap-1 tracking-wider">
							<span>Make payment now </span>{" "}
							<Image preview={false} src={lock} alt={""} />
						</button>
					</div>
				</>
			)}
		</ItemWrapper>
	);
};

export default ShopItem;
